<template>
  <div class="unified-task-page">
    <div class="btn-list-box">
      <Button type="error" @click="submit">查询</Button>
      <Button type="error" ghost @click="reset">重置</Button>
    </div>
    <FormLayout class="form-box" :defaultColumn="defaultColumn" ref="FormLayoutone" :defaultconfig="formConfig">
      <!-- <div slot="buttonSlot">
        <Button type="posdefault" style="margin-left:120px" @click="submit">提交</Button>
        <Button type="posdefault" style="margin-left:120px" @click="reset">重置</Button>
      </div> -->
    </FormLayout>
    <Page class="page-box" :current="pageNum" :total="totalCount" :page-size-opts="pageSizeOpts" size="small" show-elevator show-sizer show-total @on-change="pageChange" @on-page-size-change="pageSizeChange" />
    <Table class="table-box" border :columns="tableColumns" :data="tableData" :height="tableH" :loading="loading"></Table>
  </div>
</template>

<script>
import axios from 'axios'
import dateUtil from "commonJs/date.js";

export default {
  data() {
    return {
      tableH: 0,
      defaultColumn: 4,
      formConfig: [
        // {
        //   item: {
        //     type: 'Input', // 组件类型
        //     required: true, // 是否必填
        //     field: 'key1',
        //     label: 'Input组件',
        //     props: {
        //       placeholder: '后台字段',
        //       value: '',
        //       regularMessage: '请输入内容', // 报错提示
        //       // regx: /^d+$|^d+[.]?d+$/ // 校验规则
        //     },
        //     event: {
        //       'on-change': (e) => {
        //       }
        //     }
        //   }
        // },
        // {
        //   show: true,// 是否显示隐藏
        //   row: 1, // 行高
        //   col: 1, // 列宽
        //   item: {
        //     type: 'Select', // 组件类型
        //     required: false,
        //     field: 'BILL_TYPE',
        //     label: '单据类型',
        //     props: {
        //       placeholder: '后台字段',
        //       multiple: true,
        //       options: [{
        //         value: 'New York',
        //         label: 'New York'
        //       },
        //       {
        //         value: 'London',
        //         label: 'London'
        //       },
        //       {
        //         value: 'Sydney',
        //         label: 'Sydney'
        //       },
        //       {
        //         value: 'Ottawa',
        //         label: 'Ottawa'
        //       },
        //       {
        //         value: 'Paris',
        //         label: 'Paris'
        //       },
        //       {
        //         value: 'Canberra',
        //         label: 'Canberra'
        //       }]
        //     },
        //     event: {
        //       'on-change': (e) => {
        //         console.log(e);
        //       }
        //     }
        //   }
        // },
        // {
        //   show: true,// 是否显示隐藏
        //   col: 2, // 列宽
        //   item: {
        //     soltName: 'buttonSlot'// 组件类型
        //   }
        // }

      ],
      // formValue: {},
      queryListParams: { "table": "UNIFIED_TASKS", "startindex": 0, "range": 10, "fixedcolumns": {}, "column_include_uicontroller": true, "isolr": false },
      tableColumns: [],
      tableEventColumns: [
        {
          title: '详情',
          key: 'action',
          width: 100,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  ghost: true,
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.go2page(params.row)
                  }
                }
              }, '查看明细'),
              // h('Button', {
              //   props: {
              //     type: 'error',
              //     size: 'small'
              //   },
              //   on: {
              //     click: () => {
              //       this.remove(params.index)
              //     }
              //   }
              // }, 'Delete')
            ]);
          }
        },
        // {
        //   title: '修改时间',
        //   key: 'modifiedDate',
        //   render: (h, params) => {
        //     let modifiedDate = dateUtil.getFormatDate(new Date(params.row.modifiedDate), "yyyy-MM-dd HH:mm:ss")
        //     return h('div', modifiedDate);
        //   }
        // },
      ],
      tableData: [],
      totalCount: 0,
      originList: [],
      // pageSizeOpts: [10, 20, 30, 50, 100],
      pageSizeOpts: [],
      pageSize: 10,
      pageNum: 1,
      loading: false
    }
  },
  computed: {

  },
  watch: {
    pageNum() {
      this.getList()
    },
    pageSize() {
      this.getList()
    }
  },
  created() {
    window.addEventListener('exeActionSuccessForR3', this.listenFunc)
    this.getTableQuery()
    this.tableH = document.body.offsetHeight - 210
  },
  destroyed() {
    window.removeEventListener('exeActionSuccessForR3', this.listenFunc)
  },
  methods: {
    reset() {
      this.$refs.FormLayoutone.reset();
      this.pageNum = 1
      this.queryListParams.fixedcolumns = {}
      this.queryListParams.fixedcolumns.PROCESSING_TIME = new Date().addDays(new Date(), -30).Format('yyyyMMdd') + '~' + new Date().Format('yyyyMMdd')
      // console.log('formData =>', this.$refs.FormLayoutone.formData);
      this.getTableQuery()
    },
    submit() {
      // let verifyMessage = this.$refs.FormLayoutone.verifyMessage();
      // this.$Message.warning(verifyMessage[0] && verifyMessage[0].tip)
      // console.log(verifyMessage, this.$refs.FormLayoutone.formData);
      let formData = this.$refs.FormLayoutone.formData
      console.log('formData =>', formData);
      this.queryListParams.fixedcolumns = {}
      // 单据编号
      if (formData.BILL_NO) {
        this.queryListParams.fixedcolumns.BILL_NO = formData.BILL_NO
      }
      //单据类型
      if (formData.BILL_TYPE) {
        let newBillType = formData.BILL_TYPE.map(item => {
          return '=' + item
        })
        this.queryListParams.fixedcolumns.BILL_TYPE = newBillType
      }
      //单据状态
      if (formData.BILL_STATUS) {
        let newBillStatus = formData.BILL_STATUS.map(item => {
          return '=' + item
        })
        this.queryListParams.fixedcolumns.BILL_STATUS = newBillStatus
      }
      //业务单元
      if (formData.CP_C_BUS_UNIT_ID) {
        this.queryListParams.fixedcolumns.CP_C_BUS_UNIT_ID = formData.CP_C_BUS_UNIT_ID
      }
      //所属大区
      if (formData.CP_C_BIG_AREA_ID) {
        this.queryListParams.fixedcolumns.CP_C_BIG_AREA_ID = formData.CP_C_BIG_AREA_ID
      }
      //所属省区
      if (formData.CP_C_PROV_AREA_ID) {
        this.queryListParams.fixedcolumns.CP_C_PROV_AREA_ID = formData.CP_C_PROV_AREA_ID
      }
      //客户/店铺编码
      if (formData.ECODE) {
        this.queryListParams.fixedcolumns.ECODE = formData.ECODE
      }
      //客户/店铺名称
      if (formData.ENAME) {
        this.queryListParams.fixedcolumns.ENAME = formData.ENAME
      }
      //处理时间
      if (formData.PROCESSING_TIME && formData.PROCESSING_TIME.every(item => item != '')) {
        let newDate = formData.PROCESSING_TIME.map(item => {
          return dateUtil.getFormatDate(item, "yyyyMMdd")
        })
        this.queryListParams.fixedcolumns.PROCESSING_TIME = newDate.join('~')
      }

      this.getList()
    },
    getTableQuery() {
      let formdata = new FormData();
      // formdata.append('table', 'CL_C_STORE_BILL_QUERY');
      formdata.append('table', 'UNIFIED_TASKS');
      formdata.append('getcmd', 'y')
      axios({
        url: '/p/cs/getTableQuery',
        method: 'post',
        data: formdata
      }).then(res => {
        // console.log('getTableQuery.res :>> ', res);
        if (res.data.code == 0 && res.data.datas) {
          let dataarry = res.data.datas.dataarry
          // console.log('getTableQuery.dataarry :>> ', dataarry);
          let configList = this.convertTableQuery(dataarry)
          this.formConfig = configList
          this.queryListParams.fixedcolumns.PROCESSING_TIME = new Date().addDays(new Date(), -30).Format('yyyyMMdd') + '~' + new Date().Format('yyyyMMdd')
          this.getList()
        }
      }).finally(_ => {
        // this.loading = false
      })
    },
    convertTableQuery(dataarry) {
      function formatOptions(combobox) {
        return combobox.map(item => {
          return {
            value: item.limitval,
            label: item.limitdesc,
          }
        })
      }
      let displayColname = ['BILL_TYPE', 'BILL_STATUS', 'BILL_NO', 'ECODE', 'ENAME', 'PROCESSING_TIME', 'CP_C_BIG_AREA_ID', 'CP_C_PROV_AREA_ID', 'CP_C_BUS_UNIT_ID']
      let list = []
      dataarry.filter(item => displayColname.includes(item.colname)).forEach(ele => {
        // if (ele.display === 'OBJ_SELECT' && ele.colname === 'BILL_TYPE') {
        if (ele.display === 'OBJ_SELECT') {
          list.push({
            item: {
              type: 'Select', // 组件类型combobox
              field: ele.colname,
              label: ele.coldesc,
              props: {
                clearable: true,
                placeholder: '请选择' + ele.coldesc,
                multiple: true,
                chooseAll: true,
                options: formatOptions(ele.combobox)
              },
            }
          })
        }
        if (!ele.display) {
          list.push({
            item: {
              type: 'Input', // 组件类型
              field: ele.colname,
              label: ele.coldesc,
              props: {
                clearable: true,
                placeholder: '请输入' + ele.coldesc,
                value: '',
              },
            }
          })
        }
        if (ele.display === 'OBJ_DATE') {
          let startDate = new Date().addDays(new Date(), -30)
          // console.log('aa :>> ', aa);
          list.push({
            // col: 2, // 列宽
            item: {
              type: 'DatePicker', // 组件类型
              field: ele.colname,
              label: ele.coldesc,
              props: {
                clearable: true,
                placeholder: '请选择' + ele.coldesc,
                type: "daterange",
                style: "width: 100%",
                value: [startDate, new Date()],
              },
            }
          })
        }
        if (ele.display === 'OBJ_FK') {
          if (ele.fkobj.searchmodel === 'mrp') {
            let obj = {};
            obj.item = {
              type: 'DropMultiSelectFilter', // 组件类型
              field: ele.colname,
              label: ele.coldesc,
              inputname: ele.inputname,
              props: {
                placeholder: '请选择' + ele.coldesc,
                single: false,
                data: {},
                fk_type: 'mrp',
                fkobj: ele.fkobj,
                AutoData: [],
                hidecolumns: ['id']
              },
            }
            obj.item.event = {
              'on-popper-hide': () => {
                // 初始化清空数据
                obj.item.props.data = {};
              },
              'on-popper-show': ($this) => {
                // 当外键下拉站开始去请求数据
                this.fkQueryList({
                  searchObject: {
                    isdroplistsearch: true,
                    refcolid: ele.colid,
                    startindex: 0,
                    range: $this.pageSize
                  },
                  serviceId: ele.fkobj.serviceId,
                  success: (res) => {
                    obj.item.props.data = Object.assign({}, res.data.datas);
                    obj.item.props.totalRowCount = res.data.datas.totalRowCount;
                    obj.item.props.pageSize = res.data.datas.defaultrange;
                  }
                });
              },
              'on-page-change': (value, $this) => {
                this.fkQueryList({
                  searchObject: {
                    isdroplistsearch: true,
                    refcolid: ele.colid,
                    startindex: $this.data.defaultrange * ($this.currentPage - 1),
                    range: $this.pageSize
                  },
                  serviceId: ele.fkobj.serviceId,
                  success: (res) => {
                    obj.item.props.data = Object.assign({}, res.data.datas);
                    obj.item.props.totalRowCount = res.data.datas.totalRowCount;
                    obj.item.props.pageSize = res.data.datas.defaultrange;
                  }
                });
              },
              'on-input-value-change': (value, $this) => {
                //下拉多选模糊搜索事件
                // console.log('on-input-value-change.value =>', value);
                // console.log('on-input-value-change.$this =>', $this);
                let params = {
                  ak: value,
                  colid: ele.colid,
                  fixedcolumns: {}
                };
                this.$network.post('/p/cs/fuzzyquerybyak', this.$urlSearchParams(params)).then(
                  res => {
                    // console.log('fuzzyquerybyak.res =>', res);
                    let arr = [];
                    res.data.data.forEach(item => {
                      let obj = {};
                      obj['id'] = item['id'];
                      obj['name'] = item['ENAME'];
                      // obj['value'] = item['value'];
                      arr.push(obj);
                    });
                    console.log('autoData =>', arr)
                    obj.item.props.AutoData = arr;
                  }
                )
              },
              'on-fkrp-selected': (value, $this) => {
                //下拉单选选中事件
                // console.log('on-fkrp-selected.value =>', value);
                // console.log('on-fkrp-selected.$this =>', $this);
                switch (ele.fkobj.searchmodel) {
                  case 'drp':
                    // obj.item.value = value[0].ID;
                    obj.item.props.value = value[0].ID;
                    break;
                  case 'mrp':
                    const ids = [];
                    value.map(
                      item => {
                        ids.push(Number(item.ID))
                      }
                    );
                    obj.item.props.value = ids;
                    // console.log('this.$refs.FormLayoutone.formData.CP_C_BIG_AREA_ID :>> ', this.$refs.FormLayoutone.formData.CP_C_BIG_AREA_ID);
                    // this.$refs.FormLayoutone.formData.CP_C_BIG_AREA_ID = ids
                    break
                }

              },
              'on-clear': () => {
                // console.log('obj :>> ', obj);
                this.$refs.FormLayoutone.formData[obj.item.field] = undefined
                obj.item.props.value = undefined
              }
            }
            list.push(obj)
          }

        }
      })
      // console.log('convertTableQuery.list :>> ', list);
      return list
    },
    fkQueryList(params) {
      this.$network.post('/p/cs/QueryList', this.$urlSearchParams({
        searchdata: params.searchObject
      }), {
        serviceId: params.serviceId
      }).then((res) => {
        if (typeof params.success === 'function') {
          params.success(res);
        }
      });
    },
    // fkFuzzyquerybyak(params) {
    //   return this.$network.post('/p/cs/fuzzyquerybyak', this.$urlSearchParams(params))
    // },
    listenFunc(data) {
      // console.log('refresh');
      this.getList()
    },
    getList(isFirst) {
      // let param = {
      //   // isTest: 1
      //   startIndex: (this.pageNum - 1) * this.pageSize,
      //   range: this.pageSize
      // }
      // this.loading = true
      // axios({
      //   url: '/p/cs/scrm/unifiedtasks',
      //   method: 'post',
      //   data: param
      // }).then(res => {
      //   // console.log('getList.res :>> ', res);
      //   if (res.data.data.code == 0) {
      //     // console.log('getList.data :>> ', res.data.data.data);
      //     // this.originList = res.data.data.data
      //     this.tableData = res.data.data.data
      //     this.totalCount = res.data.data.totalRowCount
      //     // this.pageChange(1)
      //   }
      // }).finally(_ => {
      //   this.loading = false
      // })

      this.loading = true
      // let param = { "table": "UNIFIED_TASKS", "startindex": (this.pageNum - 1) * this.pageSize, "range": this.pageSize, "fixedcolumns": {}, "column_include_uicontroller": true, "isolr": false }
      this.queryListParams.startindex = (this.pageNum - 1) * this.pageSize
      this.queryListParams.range = this.pageSize

      this.$network.post('/p/cs/QueryList', this.$urlSearchParams({
        searchdata: this.queryListParams
      })).then((res) => {
        //  console.log('res :>> ', res);
        if (res.data.code === 0) {
          // console.log('datas :>> ', res.data.datas);
          let tabth = res.data.datas.tabth
          let newTabth = tabth.map(item => {
            return {
              title: item.name,
              key: item.colname,
            }
          })
          // console.log('newTabth :>> ', newTabth);
          this.tableColumns = newTabth.concat(this.tableEventColumns)
          this.pageSizeOpts = res.data.datas.selectrange
          // this.pageSize = res.data.datas.rowCount
          this.totalCount = res.data.datas.totalRowCount

          // console.log('res.data.datas.row :>> ', res.data.datas.row);
          let newtTableData = res.data.datas.row.map(item => {
            // console.log('item :>> ', item);
            for (const key in item) {
              if (Object.hasOwnProperty.call(item, key)) {
                const element = item[key];
                // console.log('element :>> ', element);
                item[key] = (element.val === 'null') ? '' : element.val
              }
            }
            // console.log('item :>> ', item);
            return item
          })
          this.tableData = newtTableData
        }
      }).finally(_ => {
        this.loading = false
      });
    },
    go2page(row) {
      // console.log('go2page.row :>> ', row);
      // 待办任务
      // this.$store.commit("global/tabOpen", {
      //   type: 'tableDetailVertical',
      //   tableName: 'CP_C_STORE_INFO_CHG',
      //   tableId: 249130166,
      //   id: 22,
      // })

      //财务管理
      //   this.$store.commit("global/tabOpen", {
      //   type: 'tableDetailVertical',
      //   tableName: 'CL_C_STORE_OPEN_NEW_FI',
      //   tableId: 249130506,
      //   id: 18732,
      // })

      //财务审核
      //   this.$store.commit("global/tabOpen", {
      //   type: 'tableDetailVertical',
      //   tableName: 'CL_C_STORE_OPEN_NEW_SH',
      //   tableId: 249130508,
      //   id: 18683,
      // })

      //   this.$store.commit("global/tabOpen", {
      //   type: 'tableDetailVertical',
      //   tableName: 'CP_C_STORE_RENEW',
      //   tableId: 249130173,
      //   id: 354,
      //   dynamicRoutingForCustomizePage: true //自定义界面跳转某一个单对象界面，单对象界面的返回按钮需要回到来源自定义界面
      // })
      // window.jflowEventParam = null
      // if (row.instanceId && row.nodeId && row.taskId) {
      //   window.jflowEventParam = {
      //     instanceId: row.instanceId,
      //     nodeId: row.nodeId,
      //     taskId: row.taskId
      //   }
      // }
      // this.$store.commit("global/tabOpen", {
      //   type: 'tableDetailVertical',
      //   tableName: row.tableName,
      //   tableId: row.tableId,
      //   id: row.objId,
      //   dynamicRoutingForCustomizePage: true //自定义界面跳转某一个单对象界面，单对象界面的返回按钮需要回到来源自定义界面
      // })

      // return
      window.jflowEventParam = null
      if (row.INSTANCE_ID && row.NODE_ID && row.TASK_ID) {
        window.jflowEventParam = {
          instanceId: row.INSTANCE_ID,
          nodeId: row.NODE_ID,
          taskId: row.TASK_ID
        }
      }
      this.$store.commit("global/tabOpen", {
        type: 'tableDetailVertical',
        tableName: row._TABLENAME,
        tableId: row._TABLEID,
        id: row.OBJID,
        // dynamicRoutingForCustomizePage: true //自定义界面跳转某一个单对象界面，单对象界面的返回按钮需要回到来源自定义界面
      })
      // sessionStorage.setItem(‘routeMapRecord’,JSON.stringify({‘当前模块名’：‘返回的路由界面’}))
      // sessionStorage.setItem('routeMapRecord',JSON.stringify({'V.CL_C_STORE_CLOSE.249130170.791': '/CUSTOMIZED/UNIFIEDTASK/31460266'}))
      let go2pageStr = `V.${row._TABLENAME}.${row._TABLEID}.${row.OBJID}`
      let routeMapRecord = {}
      routeMapRecord[go2pageStr] = '/CUSTOMIZED/UNIFIEDTASK/31460266'
      sessionStorage.setItem('routeMapRecord',JSON.stringify(routeMapRecord))
    },
    remove(index) {
      this.tableData.splice(index, 1);
    },
    pageChange(pageNum) {
      // console.log('pageNum :>> ', pageNum);
      this.pageNum = pageNum
    },
    pageSizeChange(pageSize) {
      // console.log('pageSize :>> ', pageSize);
      this.pageSize = pageSize
    }
  },
}
</script>

<style lang="less">
.unified-task-page {
  padding: 8px 0;

  .btn-list-box {
  }
  .form-box {
    margin-top: 10px;
    padding: 6px 0;
    padding-right: 10px;
    border: solid 1px #e2e2e2;
  }
  .page-box {
    margin-top: 20px;
  }
  .table-box {
    margin-top: 10px;
  }
  .ark-table-border th,
  .ark-table-border td {
    height: 30px;
  }
}
</style>
